// @ts-nocheck
import PropTypes from "prop-types";
import {transformFiguresToAnimalData} from "../../../../../utils/lotteryDataTransformers";

const gridContainerCls =
  "w-[604.56px] h-[2084.66px] flex flex-col gap-1 min-[1001px]:max-[1350px]:w-[var(--size-125)] min-[1001px]:max-[1350px]:h-[1600px] min-[1001px]:max-[1350px]:gap-[3px] min-[769px]:max-[1000px]:w-[440px] min-[769px]:max-[1000px]:h-[1550px] min-[769px]:max-[1000px]:gap-0.5 max-[768px]:w-[264px] max-[768px]:h-auto max-[768px]:gap-0 max-[420px]:w-[240px]";
const topSectionCls =
  "w-full h-[var(--size-45)] flex gap-1 min-[1001px]:max-[1350px]:h-[150px] min-[1001px]:max-[1350px]:gap-[3px] min-[769px]:max-[1000px]:h-[var(--size-32-5)] min-[769px]:max-[1000px]:gap-0.5 max-[768px]:h-[86px] max-[768px]:gap-0 max-[768px]:w-[264px] max-[420px]:h-20 max-[420px]:w-[240px]";
const specialButtonCls =
  "flex-1 bg-[var(--color-roulette-green)] border border-[var(--color-secondary)] text-white cursor-pointer flex flex-col items-center justify-center transition-all duration-200 relative p-2.5 overflow-hidden hover:opacity-80 hover:scale-[1.02] min-[1001px]:max-[1350px]:p-2 min-[769px]:max-[1000px]:p-1.5 max-[768px]:w-[132px] max-[768px]:flex-[0_0_132px] max-[420px]:w-[var(--size-30)] max-[420px]:flex-[0_0_120px]";
const specialNumberCls =
  "absolute top-2 left-2 text-[var(--font-display)] font-bold leading-[var(--leading-5xl)] min-[1001px]:max-[1350px]:text-[var(--font-display)] min-[1001px]:max-[1350px]:leading-[var(--leading-4xl)] min-[1001px]:max-[1350px]:top-1.5 min-[1001px]:max-[1350px]:left-1.5 min-[769px]:max-[1000px]:text-4xl min-[769px]:max-[1000px]:leading-[var(--leading-3xl)] min-[769px]:max-[1000px]:top-[5px] min-[769px]:max-[1000px]:left-[5px] max-[768px]:text-[var(--font-h1)] max-[768px]:top-1 max-[768px]:left-1 max-[768px]:z-[5] max-[420px]:text-xl max-[420px]:top-0.5 max-[420px]:left-0.5 max-[420px]:leading-5";
const ballenaCls =
  "!bg-[radial-gradient(circle,var(--color-roulette-green-gradient)_0%,var(--color-roulette-green)_60%)] !rounded-tl-[20px] !rounded-tr-none !rounded-br-none !rounded-bl-none !border !border-[var(--color-secondary)] max-[768px]:!rounded-tl-[18px] max-[420px]:!rounded-tl-[16px]";
const delfinCls =
  "!bg-[radial-gradient(circle,var(--color-roulette-green-gradient)_0%,var(--color-roulette-green)_60%)] !rounded-tr-[20px] !rounded-tl-none !rounded-br-none !rounded-bl-none !border !border-[var(--color-secondary)] max-[768px]:!rounded-tr-[18px] max-[420px]:!rounded-tr-[16px]";
const animalGridCls = "flex-1 flex flex-col gap-0.5";
const animalRowCls =
  "flex gap-0.5 h-[156.51px] min-[1001px]:max-[1350px]:h-[var(--size-32-5)] min-[1001px]:max-[1350px]:gap-0.5 min-[769px]:max-[1000px]:h-[115px] min-[769px]:max-[1000px]:gap-0.5 max-[768px]:h-[86px] max-[768px]:gap-0 max-[420px]:h-20";
const animalButtonCls =
  "w-[200.33px] h-[156.51px] border border-[var(--color-secondary)] rounded text-white cursor-pointer flex flex-col items-center justify-center transition-all duration-200 relative p-2 overflow-hidden hover:opacity-80 hover:scale-[1.02] hover:z-10 min-[1001px]:max-[1350px]:w-[166px] min-[1001px]:max-[1350px]:h-[var(--size-32-5)] min-[1001px]:max-[1350px]:p-1.5 min-[769px]:max-[1000px]:w-[146px] min-[769px]:max-[1000px]:h-[115px] min-[769px]:max-[1000px]:p-[var(--space-1-5)] max-[768px]:w-[88px] max-[768px]:h-[86px] max-[768px]:flex-[0_0_88px] max-[768px]:p-1 max-[420px]:w-20 max-[420px]:h-20 max-[420px]:flex-[0_0_80px]";
const animalNumberCls =
  "absolute top-2 left-2 text-[var(--font-display)] font-bold leading-[var(--leading-5xl)] min-[1001px]:max-[1350px]:text-[var(--font-display)] min-[1001px]:max-[1350px]:leading-[var(--leading-4xl)] min-[1001px]:max-[1350px]:top-1.5 min-[1001px]:max-[1350px]:left-1.5 min-[769px]:max-[1000px]:text-4xl min-[769px]:max-[1000px]:leading-[var(--leading-3xl)] min-[769px]:max-[1000px]:top-[5px] min-[769px]:max-[1000px]:left-[5px] max-[768px]:text-[var(--font-h2)] max-[768px]:top-1 max-[768px]:left-1 max-[420px]:text-[var(--font-h3)] max-[420px]:leading-[17px] max-[420px]:top-0.5 max-[420px]:left-0.5 max-[420px]:z-[5]";
const animalIconCls =
  "w-[123px] h-[123px] object-contain ml-[50px] -mt-2.5 min-[1001px]:max-[1350px]:w-[var(--size-25)] min-[1001px]:max-[1350px]:h-[var(--size-25)] min-[1001px]:max-[1350px]:ml-[42px] min-[1001px]:max-[1350px]:-mt-2 min-[769px]:max-[1000px]:w-[var(--size-22-5)] min-[769px]:max-[1000px]:h-[var(--size-22-5)] min-[769px]:max-[1000px]:ml-[38px] min-[769px]:max-[1000px]:-mt-[7px] max-[768px]:w-[47px] max-[768px]:h-[47px] max-[768px]:ml-2 max-[768px]:-mt-0.5 max-[420px]:w-[39px] max-[420px]:h-[39px] max-[420px]:ml-[7px]";
const redCls =
  "bg-[radial-gradient(circle,var(--color-roulette-red-light)_0%,var(--color-roulette-red)_100%)] shadow-[inset_0_0_20px_1px_rgba(0,0,0,0.6)]";
const darkCls = "bg-[radial-gradient(circle,var(--color-roulette-black-highlight)_0%,var(--color-roulette-black)_90%)]";
const venadoCls = "rounded-bl-[20px] max-[768px]:rounded-bl-[16px] max-[420px]:rounded-bl-[14px]";
const culebraCls = "rounded-br-[20px] max-[768px]:rounded-br-[16px] max-[420px]:rounded-br-[14px]";
const betChipCls =
  "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[67px] h-[67px] rounded-full bg-white border-[3px] border-[var(--color-roulette-red-accent)] flex items-center justify-center z-10 transition-all duration-200 shadow-[0_4px_8px_rgba(0,0,0,0.3)] pointer-events-none hover:scale-105 min-[1001px]:max-[1350px]:w-[55px] min-[1001px]:max-[1350px]:h-[55px] min-[769px]:max-[1000px]:w-[var(--size-12-5)] min-[769px]:max-[1000px]:h-[var(--size-12-5)] max-[768px]:w-10 max-[768px]:h-10 max-[768px]:border-2 max-[420px]:w-[35px] max-[420px]:h-[35px]";
const betChipDeletionModeCls =
  "!border-[var(--color-sports-glow-to)] !bg-[var(--color-roulette-red-soft-bg)] !cursor-pointer !pointer-events-auto animate-roulette-pulse hover:!scale-[1.15] hover:!shadow-[0_0_15px_rgba(255,0,0,0.6)] [&_.betChipAmount]:!text-[var(--color-sports-glow-to)]";
const betChipAmountCls =
  "betChipAmount text-xl font-bold text-[var(--color-roulette-red-accent)] bg-white text-center min-[1001px]:max-[1350px]:text-[var(--font-h3)] min-[769px]:max-[1000px]:text-base max-[768px]:text-sm max-[420px]:text-xs";

const colorClsMap = {red: redCls, dark: darkCls};
const cornerClsMap = {venado: venadoCls, culebra: culebraCls};

const NumberGrid = ({
  onNumberClick,
  placedBets = [],
  maxBetPerOption = 1000,
  onMaxBetReached,
  isDeletionMode = false,
  figures = [],
}) => {
  const getAnimalData = () => {
    if (figures && figures.length > 0) {
      const transformed = transformFiguresToAnimalData(figures);

      return transformed;
    }

    return [
      {number: 1, name: "carnero", color: "red"},
      {number: 2, name: "toro", color: "dark"},
      {number: 3, name: "ciempies", color: "red"},
      {number: 4, name: "alacran", color: "dark"},
      {number: 5, name: "leon", color: "red"},
      {number: 6, name: "rana", color: "dark"},
      {number: 7, name: "perico", color: "red"},
      {number: 8, name: "raton", color: "dark"},
      {number: 9, name: "aguila", color: "red"},
      {number: 10, name: "tigre", color: "dark"},
      {number: 11, name: "gato", color: "dark"},
      {number: 12, name: "caballo", color: "red"},
      {number: 13, name: "mono", color: "dark"},
      {number: 14, name: "paloma", color: "red"},
      {number: 15, name: "zorro", color: "dark"},
      {number: 16, name: "oso", color: "red"},
      {number: 17, name: "pavo", color: "dark"},
      {number: 18, name: "burro", color: "red"},
      {number: 19, name: "chivo", color: "red"},
      {number: 20, name: "cochino", color: "dark"},
      {number: 21, name: "gallo", color: "red"},
      {number: 22, name: "camellos", color: "dark"},
      {number: 23, name: "cebra", color: "red"},
      {number: 24, name: "iguana", color: "dark"},
      {number: 25, name: "gallina", color: "red"},
      {number: 26, name: "vaca", color: "dark"},
      {number: 27, name: "perro", color: "red"},
      {number: 28, name: "zamuro", color: "dark"},
      {number: 29, name: "elefante", color: "dark"},
      {number: 30, name: "caiman", color: "red"},
      {number: 31, name: "lapa", color: "dark"},
      {number: 32, name: "ardilla", color: "red"},
      {number: 33, name: "pescado", color: "red"},
      {number: 34, name: "venado", color: "red"},
      {number: 35, name: "jirafa", color: "dark"},
      {number: 36, name: "culebra", color: "red"},
    ];
  };

  const animalData = getAnimalData();

  const specialNumbers = animalData.filter(animal => animal.number === "00" || animal.number === "0");
  const regularNumbers = animalData.filter(animal => animal.number !== "00" && animal.number !== "0");

  const createGridLayout = () => {
    const grid = [];
    for (let row = 0; row < 12; row++) {
      const currentRow = [];
      for (let col = 0; col < 3; col++) {
        const index = row * 3 + col;
        if (index < regularNumbers.length) {
          currentRow.push(regularNumbers[index]);
        }
      }
      grid.push(currentRow);
    }
    return grid;
  };

  const gridLayout = createGridLayout();

  const getFichasForAnimal = animalId => {
    const animalBet = placedBets.find(bet => bet.animalId === animalId);
    return animalBet ? animalBet.fichas : [];
  };

  const getTotalBetForAnimal = animalId => {
    const fichas = getFichasForAnimal(animalId);
    return fichas.reduce((sum, ficha) => sum + ficha.value, 0);
  };

  const renderBetChip = animalId => {
    const fichas = getFichasForAnimal(animalId);
    if (fichas.length === 0) return null;

    const totalBet = getTotalBetForAnimal(animalId);

    return (
      <div
        className={`${betChipCls} ${isDeletionMode ? betChipDeletionModeCls : ""}`}
        title={isDeletionMode ? `Click para eliminar ($${totalBet})` : `Total apostado: ${totalBet}`}
      >
        <div className={betChipAmountCls}>{totalBet}</div>
      </div>
    );
  };

  const handleAnimalClick = animal => {
    const animalId = animal.number === "00" || animal.number === "0" ? animal.number : animal.number;

    if (isDeletionMode) {
      if (onNumberClick) {
        onNumberClick({
          betType: "animal",
          value: animal.number,
          name: animal.name,
          odds: "36:1",
        });
      }
      return;
    }

    const animalMaxBet = animal.maxBet || maxBetPerOption;

    const currentTotal = getTotalBetForAnimal(animalId);
    if (currentTotal >= animalMaxBet) {
      if (onMaxBetReached) {
        onMaxBetReached(animalId, animalMaxBet);
      }
      return;
    }

    if (onNumberClick) {
      onNumberClick({
        betType: "animal",
        value: animal.number,
        name: animal.name,
        odds: "36:1",
        maxBet: animalMaxBet,
      });
    }
  };

  return (
    <div className={gridContainerCls}>
      <div className={topSectionCls}>
        {specialNumbers.map((animal, index) => {
          const imageUrl = animal.imageUrl || `/src/assets/images/lottery-icons/${animal.name}.svg`;
          const specialClass = index === 0 ? ballenaCls : delfinCls;

          return (
            <button
              key={animal.number}
              type="button"
              className={`${specialButtonCls} ${specialClass}`}
              onClick={() => handleAnimalClick(animal)}
            >
              <span className={specialNumberCls}>{animal.number}</span>
              <img
                src={imageUrl}
                alt={animal.displayName}
                className={animalIconCls}
                loading="eager"
                onError={e => {
                  e.target.src = `/src/assets/images/lottery-icons/${animal.name}.svg`;
                }}
              />
              {renderBetChip(animal.number)}
            </button>
          );
        })}

        {specialNumbers.length === 0 && (
          <>
            <button
              type="button"
              className={`${specialButtonCls} ${ballenaCls}`}
              onClick={() => handleAnimalClick({number: "00", name: "ballena", maxBet: maxBetPerOption})}
            >
              <span className={specialNumberCls}>00</span>
              <img
                src="/src/assets/images/lottery-icons/ballena.svg"
                alt="Ballena"
                className={animalIconCls}
                loading="eager"
              />
              {renderBetChip("00")}
            </button>

            <button
              type="button"
              className={`${specialButtonCls} ${delfinCls}`}
              onClick={() => handleAnimalClick({number: "0", name: "delfin", maxBet: maxBetPerOption})}
            >
              <span className={specialNumberCls}>0</span>
              <img
                src="/src/assets/images/lottery-icons/delfin.svg"
                alt="Delfín"
                className={animalIconCls}
                loading="eager"
              />
              {renderBetChip("0")}
            </button>
          </>
        )}
      </div>

      <div className={animalGridCls}>
        {gridLayout.map(row => (
          <div
            key={`row-${row[0]?.number || "empty"}`}
            className={animalRowCls}
          >
            {row.map(animal => (
              <button
                key={animal.number}
                type="button"
                className={`${animalButtonCls} ${colorClsMap[animal.color] || ""} ${cornerClsMap[animal.name] || ""}`}
                onClick={() => handleAnimalClick(animal)}
              >
                <span className={animalNumberCls}>{animal.number.toString().padStart(2, "0")}</span>
                <img
                  src={animal.imageUrl || `/src/assets/images/lottery-icons/${animal.name}.svg`}
                  alt={animal.displayName || animal.name}
                  className={animalIconCls}
                  loading="eager"
                  onError={e => {
                    e.target.src = `/src/assets/images/lottery-icons/${animal.name}.svg`;
                  }}
                />
                {renderBetChip(animal.number)}
              </button>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

NumberGrid.propTypes = {
  gameIdString: PropTypes.string.isRequired,
  onNumberClick: PropTypes.func,
  placedBets: PropTypes.arrayOf(
    PropTypes.shape({
      animalId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      animalName: PropTypes.string,
      fichas: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          value: PropTypes.number,
          name: PropTypes.string,
        })
      ),
    })
  ),
  maxBetPerOption: PropTypes.number,
  onMaxBetReached: PropTypes.func,
  isDeletionMode: PropTypes.bool,
  figures: PropTypes.arrayOf(PropTypes.object),
};

export default NumberGrid;
